import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import NtMaterialIcon from "./NtMaterialIcon";
import { useTheme } from "../context/ThemeContext";

function NtListEmpty({ visible = true, title, message = "No records found." }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  if (!visible) return null;

  return (
    <View style={styles.container}>
      <NtMaterialIcon
        name="format-list-bulleted"
        size={18}
        color={theme.textMute}
      />
      <NtText style={[styles.message, { marginLeft: 6 }]}>
        {title || message}
      </NtText>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      paddingVertical: 24,
    },
    message: {
      color: t.textDim,
      fontSize: 13,
      fontWeight: "500",
      textAlign: "center",
    },
  });

export default NtListEmpty;
